"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useButtonVariant = void 0;
var _react = require("react");
const variants = {
  primary: {
    color: 'primaryForeground',
    backgroundColor: 'primary',
    borderColor: 'transparent'
  },
  secondary: {
    color: 'secondaryForeground',
    backgroundColor: 'secondary',
    borderColor: 'transparent'
  },
  foregroundMuted: {
    color: 'foregroundMuted',
    backgroundColor: 'secondary',
    borderColor: 'line'
  },
  positive: {
    color: 'positiveForeground',
    backgroundColor: 'positive',
    borderColor: 'transparent'
  },
  negative: {
    color: 'negativeForeground',
    backgroundColor: 'negative',
    borderColor: 'transparent'
  }
};
const transparentVariants = {
  primary: {
    color: 'primary',
    backgroundColor: 'background',
    borderColor: 'transparent'
  },
  secondary: {
    color: 'secondaryForeground',
    backgroundColor: 'background',
    borderColor: 'transparent'
  },
  foregroundMuted: {
    color: 'foregroundMuted',
    backgroundColor: 'background',
    borderColor: 'transparent'
  },
  positive: {
    color: 'positive',
    backgroundColor: 'background',
    borderColor: 'transparent'
  },
  negative: {
    color: 'negative',
    backgroundColor: 'background',
    borderColor: 'transparent'
  }
};
const useButtonVariant = (variant, transparent) => {
  return (0, _react.useMemo)(() => (transparent ? transparentVariants : variants)[variant], [transparent, variant]);
};
exports.useButtonVariant = useButtonVariant;